
import { Enums } from '@bode-canada/core';
import ListingCard from '@/components/listing-card';
import {
  ViewListingAction,
  ViewSoldPropertyAction,
} from '@/components/listing-card/helpers/actions';

/**
   * @component SoldDataListings
   *
   * @private
   */

export default {
  name: 'SoldDataListingsCards',
  components: {
    ListingCard,
  },
  props: {
    listings: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getViewListingAction() {
      return new ViewListingAction();
    },
    getViewSoldPropertyAction() {
      return new ViewSoldPropertyAction();
    },
    isSoldListing(listing) {
      return listing.status === Enums.ListingStatusEnum.SOLD;
    },
  },
};
